export default {
  saveAuthority: '/auth/authority/request/save',
  infoAuthority: '/auth/authority/request/info',
  infoAuthoritUncheck: '/auth/authority/request/api/info',
};



// WEBPACK FOOTER //
// ./src/api/authApply.js